// Javascript's atob/btoa don't do what you expect with UTF-8 strings:
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem

function encodeFromString(str) {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
    function toSolidBytes(match, p1) {
      return String.fromCharCode('0x' + p1);
    }));
}

function decodeToString(str) {
  // Some browsers don't like whitespace here
  const stripped = str.replace(/\s/g, '');

  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(atob(stripped).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}

module.exports = {
  encodeFromString,
  decodeToString,
}



// WEBPACK FOOTER //
// ./javascripts/components/shared/base64_utf8.js